import { useEffectOnce } from 'react-use';
import { useCXI } from 'modules/cxi/useCXI';

export const Contribution = () => {
    const { modal, setModal } = useCXI();
    const { match } = modal;

    useEffectOnce(() => {
        setModal({ match, modal: 'ContributionForm' });
    }, []);

    return null;
};
